import React, { useState, useRef, useMemo } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useSupport } from '../../hooks/useSupport';
import { dashboardStyles as ds } from '../../styles/dashboardStyles';
import { ss } from '../../styles/supportStyles';

const Support = () => {
  const { user } = useAuth();
  const { sendTicket, loading } = useSupport();
  const [submitted, setSubmitted] = useState(false);
  const [fileList, setFileList] = useState([]);
  const fileInputRef = useRef(null);

  const meta = useMemo(() => user?.user_metadata || user?.raw_user_meta_data || {}, [user]);
  
  const enterprise = (meta?.enterprise || 'Sogemsa').toString().toUpperCase();
  const role = meta?.role || 'Comercio Aliado';
  const phone = meta?.phone || '';

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const totalFiles = [...fileList, ...selectedFiles];

    if (totalFiles.length > 3) {
      alert("Solo se permite un maximo de 3 archivos");
      e.target.value = "";
      return;
    }

    setFileList(totalFiles);
    e.target.value = ""; 
  };

  const clearFiles = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFileList([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(e.target).entries());
    const result = await sendTicket({ ...data, enterprise, role, user_email: user?.email }, fileList);

    if (result.success) {
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 5000);
      e.target.reset();
      setFileList([]);
    } else alert(`Error: ${result.error}`);
  };

  return (
    <section id="support" className={ds.section}>
      <div className={ds.headerContainer}>
        <h3 className={ds.headerTitle}>Soporte y Contacto</h3>
        <p className={ds.headerSubtitle}>Centro de contacto directo para gestiones operativas</p>
      </div>

      <div className={ss.formContainer}>
        <form onSubmit={handleSubmit} className={ss.supportForm}>
          {submitted && (
            <div className={ss.overlay}>
              <div className="bg-msc-green p-4 rounded-full mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="3">
                  <path d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h4 className="text-white text-xl font-black uppercase tracking-widest mb-2 text-center">Ticket Enviado</h4>
              <p className="text-slate-400 text-sm italic text-center">El equipo revisara su requerimiento pronto</p>
            </div>
          )}

          <div className={ss.sidebar}>
            <div className={ss.sidebarHeader}>
              <div className={ss.accent} />
              <div>
                <span className={ss.labelTiny}>Aliado Estratégico</span>
                <h4 className={ss.enterprise}>{enterprise}</h4>
                <p className={ss.role}>{role}</p>
              </div>
            </div>
            <div className={ss.sidebarFooter}>
              <span className={ss.footerLabel}>Canal de respuesta</span>
              <p className={ss.footerValue}>{user?.email || 'No disponible'}</p>
            </div>
          </div>

          <div className={ss.mainArea}>
            <div className={ss.inputGroup}>
              <label className={ss.inputLabel}>Telefono de contacto</label>
              <input key={phone} required name="phone" type="tel" defaultValue={phone} className={ss.inputField} />
            </div>
            <div className={ss.inputGroup}>
              <label className={ss.inputLabel}>Motivo de consulta</label>
              <div className={ss.select}>
                <select name="type" className={ss.inputField}>
                  <option value="Soporte Técnico">Soporte Técnico</option>
                  <option value="Problemas con Pagos">Problemas con Pagos</option>
                  <option value="Duda sobre Cronograma">Duda sobre Cronograma</option>
                </select>
              </div>
            </div>
            <div className={ss.inputGroup}>
              <div className="flex justify-between items-center h-5">
                <label className={ss.inputLabel}>Documentacion (Max 3)</label>
                {fileList.length > 0 && (
                  <button type="button" onClick={clearFiles} className="text-[9px] text-msc-red font-black uppercase tracking-tighter hover:underline">
                    Limpiar seleccion
                  </button>
                )}
              </div>
              <div onClick={() => fileInputRef.current.click()} className={ss.dropzone(fileList.length > 0)}>
                <input 
                  type="file" 
                  ref={fileInputRef} 
                  className="hidden" 
                  multiple 
                  accept=".png,.jpg,.jpeg,.pdf"
                  onChange={handleFileChange} 
                />
                <svg className={`w-6 h-6 mb-2 ${fileList.length > 0 ? 'text-msc-green' : 'text-slate-300'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="3">
                  <path d="M12 4v16m8-8H4" />
                </svg>
                <span className={`text-[10px] font-black uppercase tracking-widest text-center ${fileList.length > 0 ? 'text-msc-green' : 'text-slate-400'}`}>
                  {fileList.length > 0 ? `${fileList.length} / 3 archivos` : "Subir imagenes o PDF"}
                </span>
              </div>
            </div>
          </div>

          <div className={ss.actionArea}>
            <div className="flex-grow flex flex-col gap-3">
              <label className={ss.inputLabel}>Descripcion del caso</label>
              <textarea required name="message" className={ss.textarea} placeholder="Detalle su problema de forma precisa..." />
            </div>
            <button disabled={loading || !user} type="submit" className={`${ss.submitBtn} mt-8`}>
              {loading ? "Procesando" : "Enviar requerimiento"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Support;